import { useDispatch } from "react-redux";
import { logOut as logOutAuth } from "../redux/slice/authSlice";
import {
  clearCommunities,
  clearComunnitiesOfUser,
} from "../redux/slice/communitiesSlice";
import { clearMembership } from "../redux/slice/membershipSlice";
import { clearRoute } from "../redux/slice/routeSlice";
import { clearUserData } from "../redux/slice/userSlice";
import { clearRunningsClubs } from "../redux/slice/runningsClubsSlice";

const useLogOut = () => {
  const dispatch = useDispatch();
  const logOut = () => {
    dispatch(logOutAuth());
    dispatch(clearCommunities());
    dispatch(clearComunnitiesOfUser());
    dispatch(clearMembership());
    dispatch(clearRoute());
    dispatch(clearUserData());
    dispatch(clearRunningsClubs());
    // navigate()
  };
  return { logOut };
};

export default useLogOut;
